export default "__VITE_ASSET__oeYBaOYZ__"